/*
 * Checkout v2 eligibility gate - hides every Fastrr/Shiprocket checkout
 * entry point (cart-drawer button, full /cart page button, and Fastrr's
 * own dynamically-injected "BUY NOW" widgets) and swaps in a real
 * replacement instead, for eligible visitors only: a link to
 * /pages/checkout-v2 for the cart-drawer/cart-page buttons, and the new
 * in-page bottom-sheet checkout (assets/braclo-buynow-sheet.js) for the
 * per-product "BUY NOW" widget. For everyone else this script does
 * nothing, so Fastrr's own script (snippets/sr-checkout.liquid) keeps
 * working exactly as it does today.
 */
(function(){
  var STORAGE_KEY = 'braclo_checkout_v2_bucket';

  function getConfig(){
    return window.BracloCheckoutConfig || { enabled: false, rolloutPercent: 0 };
  }

  function getBucket(){
    try {
      var existing = localStorage.getItem(STORAGE_KEY);
      if (existing !== null) return parseFloat(existing);
    } catch (e) {}
    var bucket = Math.random() * 100;
    try { localStorage.setItem(STORAGE_KEY, String(bucket)); } catch (e) {}
    return bucket;
  }

  function isForced(){
    try {
      var params = new URLSearchParams(window.location.search);
      return params.get('braclo_checkout') === 'v2force';
    } catch (e) { return false; }
  }

  function isEligible(){
    var config = getConfig();
    if (isForced()) return true;
    if (!config.enabled) return false;
    var pct = Number(config.rolloutPercent) || 0;
    if (pct <= 0) return false;
    if (pct >= 100) return true;
    return getBucket() < pct;
  }

  // Fastrr renders its own "BUY NOW" widget into any element carrying this
  // class - data-type="cart" is present ahead of time in the /cart page's
  // own markup (sections/main-cart.liquid), but data-type="mini-cart" in
  // the cart drawer is added entirely by Fastrr's own script at runtime,
  // with no matching liquid markup to find in advance. Hiding by class
  // alone (not a specific data-type) covers every mount point Fastrr uses
  // without needing to enumerate them one at a time.
  function hideShiprocketWidgets(){
    document.querySelectorAll('.shiprocket-headless').forEach(function(el){
      if (el.dataset.bracloHidden) return;
      el.dataset.bracloHidden = '1';
      el.style.display = 'none';
    });
  }

  function swapCheckoutButton(){
    var original = document.querySelector('.cart-drawer-checkout-btn');
    if (!original || original.dataset.bracloSwapped) return;

    original.dataset.bracloSwapped = '1';
    original.style.display = 'none';

    var replacement = document.createElement('a');
    replacement.href = '/pages/checkout-v2';
    replacement.className = original.className;
    replacement.id = 'bracloCheckoutTrigger';
    replacement.innerHTML = original.innerHTML;
    original.insertAdjacentElement('afterend', replacement);
  }

  // The full /cart page (sections/main-cart.liquid) has its own checkout
  // entry point, separate from the drawer above: a real
  // <button type="submit" name="checkout"> inside the cart form. That
  // button is already hidden site-wide by Fastrr's own CSS
  // (button[name="checkout"]{display:none!important} in
  // snippets/sr-checkout.liquid) regardless of eligibility, so inserting a
  // real visible link in its place is what actually makes checkout
  // reachable from this page for an eligible visitor.
  function swapCartPageCheckout(){
    var original = document.querySelector('button[name="checkout"].cart-checkout-btn');
    if (!original || original.dataset.bracloSwapped) return;
    original.dataset.bracloSwapped = '1';

    var replacement = document.createElement('a');
    replacement.href = '/pages/checkout-v2';
    replacement.className = original.className;
    replacement.id = 'bracloCartCheckoutTrigger';
    replacement.innerHTML = original.innerHTML;
    original.insertAdjacentElement('afterend', replacement);
  }

  // Product-page "Buy Now" - a new button placed side-by-side with the
  // real "Add to Bag" button inside #pdpPurchaseArea, opening the new
  // in-page bottom-sheet checkout (assets/braclo-buynow-sheet.js). NOTE:
  // on this theme Fastrr does not actually inject its own per-product Buy
  // Now widget into the product page (only into the cart drawer, as
  // data-type="mini-cart" - confirmed by live inspection), so there is no
  // Fastrr element to "replace" here; this purely adds a new button.
  // Scoped to #pdpPurchaseArea specifically because .add-cart-btn also
  // matches an unrelated off-page element elsewhere in the DOM.
  //
  // Never touches .add-cart-btn/.cart-cycle-btn ITSELF - that's a
  // completely separate button (Add to Bag) with its own animation,
  // deliberately left alone: this only moves the real element (same DOM
  // node, same classes/attributes/listeners, nothing cloned or rewritten)
  // one level deeper into a new flex wrapper so it can sit side-by-side
  // with the new button. The new button has its own independent 4-message
  // rotating-text animation (see BUY_NOW_MESSAGES/startBuyNowTextCycle
  // below) - not a reuse of Add to Bag's .cart-cycle-btn keyframes, which
  // only support 2 fixed states.
  // Requires an explicit size pick first, exactly like Add to Bag's own
  // submit handler does (theme.js: reads #sizeRow .size-radio:checked,
  // and if nothing's checked, shows #sizeError + shakes #sizeRow instead
  // of proceeding) - reusing the SAME elements/classes so the error look
  // is identical, not a second competing validation UI. This matters
  // because the size radios all share name="id" with a plain
  // querySelector('input[name="id"]') just grabbing whichever one is
  // FIRST in the DOM (size S) regardless of whether the customer actually
  // picked it - only the `:checked` pseudo-class reflects a real pick.
  // Buy Now -> the new full checkout (/pages/checkout-v2: QR, call discount, backup gateway...) instead of the old
  // bottom sheet. cart/update sets this variant to exactly the chosen qty (clicking twice never doubles it); other
  // bag items stay. If the bag can't be updated (e.g. out of stock), the old sheet still opens as a fallback.
  var goingToCheckout = false;
  function goToNewCheckout(variantId, qty){
    if (goingToCheckout) return; goingToCheckout = true;
    var updates = {}; updates[String(variantId)] = Math.max(1, parseInt(qty, 10) || 1);
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function(r){ if (!r.ok) throw new Error('cart ' + r.status); goingToCheckout = false; openCheckoutSheet(); })
      .catch(function(){ goingToCheckout = false; if (window.BracloBuyNowSheet) window.BracloBuyNowSheet.open(variantId, { qty: qty }); });
  }

  // The new checkout in a small sheet over the product page. Shopify refuses to show its pages inside an iframe
  // (frame-ancestors 'none'), so the checkout section itself is fetched with the Section Rendering API and mounted
  // here - payments then run on this top-level page, so UPI apps and bank pages open normally.
  var CHECKOUT_SECTION = 'template--23315640549633__main';   // sections/braclo-checkout.liquid on /pages/checkout-v2
  function fetchCheckoutSection(){
    var get = function(id){ return fetch('/pages/checkout-v2?sections=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(j){ return j && j[id]; }); };
    return get(CHECKOUT_SECTION).then(function(html){
      if (html) return html;
      // template re-saved -> section id changed: read the current id off the page once
      return fetch('/pages/checkout-v2', { credentials: 'same-origin' }).then(function(r){ return r.text(); }).then(function(t){
        var m = t.match(/id="shopify-section-([^"]*__main)"/); if (!m) throw new Error('checkout section not found');
        CHECKOUT_SECTION = m[1]; return get(m[1]);
      });
    });
  }
  // innerHTML never runs <script> tags: re-create them in order (external ones awaited)
  function runSectionScripts(root){
    return [].slice.call(root.querySelectorAll('script')).reduce(function(chain, old){
      return chain.then(function(){ return new Promise(function(done){
        var type = (old.getAttribute('type') || '').toLowerCase();
        if (type && type !== 'text/javascript' && type !== 'module') { done(); return; }   // JSON data blocks stay as they are
        var s = document.createElement('script');
        [].slice.call(old.attributes).forEach(function(a){ if (a.name !== 'src') s.setAttribute(a.name, a.value); });
        if (old.src) {
          if (/sdk\.cashfree\.com/.test(old.src) && window.Cashfree) { done(); return; }
          s.src = old.src; s.onload = done; s.onerror = done; old.parentNode.replaceChild(s, old);
        } else { s.text = old.textContent; old.parentNode.replaceChild(s, old); done(); }
      }); });
    }, Promise.resolve());
  }
  function openCheckoutSheet(){
    var old = document.getElementById('bcSheetWrap'); if (old) old.remove();
    var mobile = window.matchMedia('(max-width: 700px)').matches;
    var wrap = document.createElement('div'); wrap.id = 'bcSheetWrap';
    wrap.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(17,16,16,.45);display:flex;align-items:' + (mobile ? 'flex-end' : 'center') + ';justify-content:center;opacity:0;transition:opacity .25s ease';
    var box = document.createElement('div');
    box.style.cssText = 'position:relative;background:#fff;width:100%;max-width:' + (mobile ? '100%' : '620px') + ';height:' + (mobile ? '92vh' : '90vh') + ';border-radius:' + (mobile ? '20px 20px 0 0' : '20px') + ';overflow:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;box-shadow:0 -10px 40px rgba(0,0,0,.25);transform:translateY(' + (mobile ? '100%' : '20px') + ');transition:transform .35s cubic-bezier(.2,.8,.2,1)';
    var close = document.createElement('button'); close.type = 'button'; close.setAttribute('aria-label', 'Close'); close.innerHTML = '&times;';
    close.style.cssText = 'position:sticky;top:10px;float:right;margin:10px 12px -46px 0;z-index:5;width:36px;height:36px;border-radius:50%;border:0;background:rgba(17,16,16,.08);font-size:22px;line-height:36px;cursor:pointer;color:#111';
    var body = document.createElement('div'); body.id = 'bcSheetBody';
    body.innerHTML = '<div style="padding:28vh 0;text-align:center;font:500 15px/1.4 system-ui,sans-serif;color:#555">Opening checkout…</div>';
    box.appendChild(close); box.appendChild(body); wrap.appendChild(box); document.body.appendChild(wrap);
    var prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden';
    requestAnimationFrame(function(){ wrap.style.opacity = '1'; box.style.transform = 'translateY(0)'; });
    function shut(){ wrap.style.opacity = '0'; box.style.transform = 'translateY(' + (mobile ? '100%' : '20px') + ')'; setTimeout(function(){ wrap.remove(); document.body.style.overflow = prevOverflow; }, 300); }
    close.addEventListener('click', shut);
    wrap.addEventListener('click', function(e){ if (e.target === wrap) shut(); });
    fetchCheckoutSection().then(function(html){
      if (!html) throw new Error('empty section');
      body.innerHTML = html;
      return runSectionScripts(body);
    }).catch(function(){ window.location.href = '/pages/checkout-v2'; });   // anything odd -> the full checkout page
  }

  function buyNowClickHandler(){
    // "Hold My Checkout" - while this button is showing "Continue checkout"
    // (see updateBuyNowContinueState), clicking it must resume the exact
    // saved variant/qty directly, skipping the normal size-selection
    // validation below entirely - the customer already picked a size once,
    // that's what got them this far.
    var saved = window.BracloBuyNowSheet.getSavedCheckout && window.BracloBuyNowSheet.getSavedCheckout();
    if (saved && saved.variantId) {
      goToNewCheckout(saved.variantId, saved.qty || 1);
      return;
    }
    var sizeRow = document.getElementById('sizeRow');
    var checkedInput = document.querySelector('#product-form input[name="id"]:checked') || document.querySelector('form[action*="/cart/add"] input[name="id"]:checked');
    if (sizeRow && !checkedInput) {
      sizeRow.classList.add('error');
      var sizeError = document.getElementById('sizeError');
      if (sizeError) {
        sizeError.textContent = 'Please select a size.';
        sizeError.classList.add('show');
      }
      sizeRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function(){ sizeRow.classList.remove('error'); }, 400);
      return;
    }
    var variantInput = checkedInput || document.querySelector('#product-form input[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var variantId = variantInput ? variantInput.value : null;
    if (!variantId) return;
    var qtyInput = document.querySelector('#product-form input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
    goToNewCheckout(variantId, qty);
  }

  // The 4 rotating messages on the new "Buy Now" button - a calm crossfade
  // + slight upward slide (150ms out, 150ms in - 300ms total, comfortably
  // inside the 250-350ms window), plain ease timing (no back/elastic
  // easing - deliberately not bouncy), holding each message for ~2s. This
  // is fully custom, NOT the site's own .cart-cycle-btn keyframe animation
  // (that one only supports 2 fixed states) - a plain setInterval swapping
  // one text node's content, guarded so it only ever starts once per
  // button even if sweep() re-runs.
  var BUY_NOW_MESSAGES = ['Buy Now — 1 Click ⚡', 'Buy Now — Secure', 'Buy Now — Ships Fast 🚚', 'Buy Now →'];
  var CONTINUE_CHECKOUT_TEXT = 'Continue checkout →';
  function startBuyNowTextCycle(textEl, btn){
    var idx = 0;
    setInterval(function(){
      // Frozen on "Continue checkout" while a Hold My Checkout session is
      // pending (see updateBuyNowContinueState) - the rotating messages
      // resume on their own the next tick after continueMode clears.
      if (btn.dataset.continueMode === '1') return;
      idx = (idx + 1) % BUY_NOW_MESSAGES.length;
      textEl.style.transition = 'opacity 150ms ease, transform 150ms ease';
      textEl.style.opacity = '0';
      textEl.style.transform = 'translateY(-6px)';
      setTimeout(function(){
        textEl.textContent = BUY_NOW_MESSAGES[idx];
        textEl.style.transition = 'none';
        textEl.style.transform = 'translateY(6px)';
        void textEl.offsetWidth; // force reflow so the next transition actually animates
        textEl.style.transition = 'opacity 150ms ease, transform 150ms ease';
        textEl.style.opacity = '1';
        textEl.style.transform = 'translateY(0)';
      }, 150);
    }, 2000);
  }

  // Wraps one real Add to Bag button (the DOM node itself, moved not
  // cloned - same classes/attributes/listeners survive intact) in a new
  // flex row alongside a new gold "Buy Now" button. flex:1 1 auto +
  // min-width:0 on the row itself (not just its two children) matters
  // specifically inside the mobile sticky bar, which is ALSO a flex row
  // (.mobile-sticky-cart{display:flex}) - without an explicit flex-basis
  // this wrapper only takes its content width as a flex item there,
  // instead of sharing the bar's width properly with its sibling(s).
  function attachBuyNowBeside(addBtn, idSuffix){
    if (!addBtn || addBtn.dataset.bracloBuyNowSwapped) return;
    addBtn.dataset.bracloBuyNowSwapped = '1';

    var row = document.createElement('div');
    row.id = 'bracloBuyNowRow' + idSuffix;
    row.style.cssText = 'display:flex;gap:10px;align-items:stretch;flex:1 1 auto;min-width:0;';
    addBtn.parentElement.insertBefore(row, addBtn);
    addBtn.style.cssText = 'flex:1 1 0;min-width:0;margin:0;';
    row.appendChild(addBtn);

    // Match Add to Bag's REAL height exactly, read live rather than
    // hardcoded - the desktop inline button and the mobile sticky button
    // are two different real elements with two different CSS-defined
    // heights (52px vs 46px, confirmed live), so a single guessed number
    // here was wrong for one of them and stretched the whole row (both
    // buttons, via align-items:stretch) taller than either was designed
    // for. Gold background instead of Add to Bag's dark ink so the two
    // read as a clear primary/secondary pair at a glance rather than
    // looking identical. overflow:hidden keeps the slide transition from
    // ever poking text outside the button's own rounded edges.
    var addBtnHeight = getComputedStyle(addBtn).height;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'bracloProductBuyNow' + idSuffix;
    btn.dataset.continueMode = '0';
    btn.style.cssText = 'flex:1 1 0;min-width:0;display:flex;align-items:center;justify-content:center;overflow:hidden;height:' + addBtnHeight + ';border:none;background:#c98f18;color:#fff;font-family:Poppins,sans-serif;font-size:12px;font-weight:500;letter-spacing:1px;cursor:pointer;';
    var textEl = document.createElement('span');
    textEl.id = 'bracloProductBuyNowText' + idSuffix;
    textEl.textContent = BUY_NOW_MESSAGES[0];
    textEl.style.cssText = 'display:inline-block;white-space:nowrap;';
    btn.appendChild(textEl);
    btn.addEventListener('click', buyNowClickHandler);
    row.appendChild(btn);
    startBuyNowTextCycle(textEl, btn);
    syncBuyNowDisabled(addBtn, btn);
  }

  // Add to Bag's disabled state covers two cases: the whole product is
  // out of stock (server-rendered `disabled`, sections/main-product.liquid
  // `{% unless product.available %}`), AND - dynamically, once a size row
  // exists - no in-stock size is currently selected (theme.js toggles this
  // live as sizes are picked/deselected, since only a single-variant
  // product gets one pre-checked by default; everything else starts with
  // nothing selected). This new "Buy Now" button was never wired to either
  // case: it stayed fully clickable - and would open the buy-now sheet for
  // whatever size happened to be first in the DOM - even while Add to Bag
  // sat greyed out right next to it (e.g. every size but one out of stock,
  // customer taps the sold-out one). Called at creation AND on every
  // sweep() (see swapProductBuyNow) since, unlike whole-product
  // availability, the size-selection half of this can flip live while the
  // page is open.
  function syncBuyNowDisabled(addBtn, btn){
    if (!addBtn || !btn) return;
    var shouldDisable = !!addBtn.disabled;
    if (btn.disabled === shouldDisable) return;
    btn.disabled = shouldDisable;
    btn.style.opacity = shouldDisable ? '.4' : '';
    btn.style.cursor = shouldDisable ? 'not-allowed' : 'pointer';
  }

  // The theme hides .add-cart-btn-inline itself below 768px (confirmed
  // live: "@media(max-width:768px){ .add-cart-btn-inline{display:none} }"
  // in sections/main-product.liquid's own <style> block) - that rule only
  // targets Add to Bag, not the new wrapper row around it, so below that
  // width Add to Bag correctly disappeared but the new gold Buy Now button
  // next to it did NOT, leaving it orphaned alone in the page content
  // (confirmed live on a real phone - a mismatch with the intended
  // inline-for-desktop/sticky-for-mobile split the theme already uses for
  // Add to Bag). Injecting one matching rule for the row, at the exact
  // same breakpoint, is the only reliable fix - CSS in main-product.liquid
  // can't be edited (out of scope), and inline styles can't express a
  // media query, so this stays the one small <style> tag this file adds.
  var RESPONSIVE_STYLE_ID = 'bracloBuyNowResponsiveStyle';
  function ensureResponsiveHideStyle(){
    if (document.getElementById(RESPONSIVE_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = RESPONSIVE_STYLE_ID;
    // The FOMO pulse (see updateBuyNowContinueState) is a growing-then-fading
    // gold ring around the button itself - same visual language as the
    // rest of the site's gold accent, just louder, since this state only
    // ever appears for a customer who already started checking out once.
    style.textContent = '@media(max-width:768px){ #bracloBuyNowRowInline{ display:none !important; } }'
      + '@keyframes bracloContinuePulse{0%,100%{box-shadow:0 0 0 0 rgba(201,143,24,.55);}50%{box-shadow:0 0 0 9px rgba(201,143,24,0);}}'
      + '.braclo-buynow-continue{animation:bracloContinuePulse 1.6s ease-in-out infinite;}'
      + '@media(prefers-reduced-motion:reduce){.braclo-buynow-continue{animation:none!important;}}';
    document.head.appendChild(style);
  }

  // "Hold My Checkout" - assets/braclo-buynow-sheet.js persists {variantId,
  // qty} to sessionStorage the moment the sheet opens (see saveActiveCheckout
  // there) and only clears it once an order is actually placed. Rather than
  // bolt on a separate "Continue checkout" banner (tried first, looked like
  // a stray third button crammed next to Add to Bag/Buy Now), the existing
  // gold Buy Now button itself transforms in place: its rotating message
  // freezes on "Continue checkout →", clicking it resumes the saved
  // variant/qty directly (see buyNowClickHandler), and a FOMO pulse ring
  // makes it impossible to miss. Runs every sweep() since the saved marker
  // can appear or clear at any time while the page is open.
  function updateBuyNowContinueState(btn, textEl){
    if (!btn || !textEl) return;
    var saved = window.BracloBuyNowSheet.getSavedCheckout && window.BracloBuyNowSheet.getSavedCheckout();
    var isContinue = !!(saved && saved.variantId);
    var wasContinue = btn.dataset.continueMode === '1';
    if (isContinue === wasContinue) return;
    btn.dataset.continueMode = isContinue ? '1' : '0';
    btn.classList.toggle('braclo-buynow-continue', isContinue);
    if (isContinue) {
      textEl.style.transition = 'opacity 150ms ease, transform 150ms ease';
      textEl.style.opacity = '0';
      textEl.style.transform = 'translateY(-6px)';
      setTimeout(function(){
        textEl.textContent = CONTINUE_CHECKOUT_TEXT;
        textEl.style.transition = 'none';
        textEl.style.transform = 'translateY(6px)';
        void textEl.offsetWidth;
        textEl.style.transition = 'opacity 150ms ease, transform 150ms ease';
        textEl.style.opacity = '1';
        textEl.style.transform = 'translateY(0)';
      }, 150);
    }
    // Turning continue mode OFF needs no explicit transition here - the
    // rotating cycle's own setInterval (paused while continueMode==='1')
    // picks back up with its normal crossfade on its next tick.
  }

  // Product-page "Buy Now" - runs for both the desktop inline Add to Bag
  // button (inside #pdpPurchaseArea) and the mobile sticky one (its own
  // #mobileStickyCart bar, entirely outside #pdpPurchaseArea - confirmed
  // live, mobile would otherwise never see a Buy Now button at all since
  // the inline one is hidden on small screens). Opens the new in-page
  // bottom-sheet checkout (assets/braclo-buynow-sheet.js). NOTE: on this
  // theme Fastrr does not actually inject its own per-product Buy Now
  // widget into the product page (only into the cart drawer, as
  // data-type="mini-cart" - confirmed by live inspection), so there is no
  // Fastrr element to "replace" here; this purely adds new buttons. Never
  // touches .add-cart-btn/.cart-cycle-btn ITSELF - see attachBuyNowBeside
  // above for exactly what "touch" means here (parent-wrap only).
  function swapProductBuyNow(){
    if (window.location.pathname.indexOf('/products/') !== 0) return;
    if (!window.BracloBuyNowSheet) return; // sheet script not loaded yet - sweep() will retry
    ensureResponsiveHideStyle();
    attachBuyNowBeside(document.querySelector('#pdpPurchaseArea .add-cart-btn.add-cart-btn-inline'), 'Inline');
    attachBuyNowBeside(document.querySelector('#mobileStickyCart .add-cart-btn.mobile-sticky-btn'), 'Sticky');
    updateBuyNowContinueState(document.getElementById('bracloProductBuyNowInline'), document.getElementById('bracloProductBuyNowTextInline'));
    updateBuyNowContinueState(document.getElementById('bracloProductBuyNowSticky'), document.getElementById('bracloProductBuyNowTextSticky'));
    syncBuyNowDisabled(document.querySelector('#pdpPurchaseArea .add-cart-btn.add-cart-btn-inline'), document.getElementById('bracloProductBuyNowInline'));
    syncBuyNowDisabled(document.querySelector('#mobileStickyCart .add-cart-btn.mobile-sticky-btn'), document.getElementById('bracloProductBuyNowSticky'));
  }

  function sweep(){
    hideShiprocketWidgets();
    swapCheckoutButton();
    swapCartPageCheckout();
    swapProductBuyNow();
  }

  // Abandoned-checkout WhatsApp recovery lands here: the backend's cron
  // sweep (routes/checkout.js sweepCheckoutV2Abandoned) texts a link back
  // to this exact product with ?bnws_resume=<variantId>&bnws_qty=<qty>.
  // Unlike the on-page "Hold My Checkout" resume (sessionStorage-based,
  // same browser/tab only), this has to work from a completely fresh
  // session on a different device - so it's a URL param, checked once on
  // load, that directly opens the sheet for that variant/qty. Retries
  // briefly since braclo-buynow-sheet.js may not have finished loading yet
  // (same reasoning as swapProductBuyNow's own "sheet script not loaded
  // yet - sweep() will retry" guard).
  function resumeFromWhatsAppLink(){
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var variantId = params.get('bnws_resume');
    if (!variantId) return;
    var qty = parseInt(params.get('bnws_qty'), 10) || 1;
    goToNewCheckout(variantId, qty); return;   // old WhatsApp resume links also land on the new checkout
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      if (window.BracloBuyNowSheet) {
        clearInterval(iv);
        window.BracloBuyNowSheet.open(variantId, { qty: qty });
      } else if (tries > 20) {
        clearInterval(iv);
      }
    }, 250);
  }

  // Fastrr's own widget UI is injected asynchronously by its own deferred
  // script - not present in the DOM yet at DOMContentLoaded. The cart
  // drawer's contents are also fully replaced (theme.js's
  // refreshCartDrawer(), an AJAX re-render) on every cart change, which
  // wipes out whatever was swapped in and brings back a fresh, un-swapped
  // original button. A MutationObserver re-runs the same idempotent sweep
  // whenever either of those happens, instead of guessing the exact
  // timing of either - every function above is a no-op once its target is
  // already handled, so repeated sweeps cost nothing.
  function init(){
    if (!isEligible()) return;
    sweep();
    resumeFromWhatsAppLink();
    var observer = new MutationObserver(sweep);
    // attributes+attributeFilter added for syncBuyNowDisabled (see
    // swapProductBuyNow): theme.js flips Add to Bag's `disabled` attribute
    // live as sizes are picked/deselected (no size checked -> disabled),
    // and that's a plain attribute mutation, not a childList change, so it
    // was invisible to this observer before - the gold Buy Now button next
    // to it never found out and stayed clickable. Filtered to `disabled`
    // specifically so this doesn't turn every attribute change on the page
    // into a full sweep().
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
